module.exports = __webpack_public_path__ + "static/media/savills1.32f85b01.jpg";